import * as uuid from "uuid";

export const Agency = {
    OfficeName: '',
    OfficeShortName: '',
    CountryGuid: uuid.NIL,
    CurrencyGuid: uuid.NIL,
    LanguageGuid: uuid.NIL
}